import { Component, OnInit } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { CoacheeService } from "src/app/core/services/coachee_services/coachee.service";
import { MeResponse } from "src/app/core/services/coachee_services/http.service";

@Component({
    selector: 'consent',
    templateUrl: './consent.component.html',
})
export class ConsentComponent implements OnInit {
    screen: 'ai-consent' | 'dpa-consent' | 'loading' | 'content' = 'loading'
    pending: boolean = false;
    dpaChecked: boolean = false;
    language: string = "";


    constructor(
        private _coacheeService: CoacheeService,
        private cookieService: CookieService,
    ) { }

    ngOnInit(): void {
        const me = this;
        const isCoachee = sessionStorage.getItem('isCoachee') == 'true';
        if (!isCoachee) {
            me.screen = 'content'
            return
        }
        this.initializeLanguage();
        this._coacheeService.getMe().then((r) => {
            me.handleMeResponse(r)
        })
    }

    initializeLanguage(): void {
        let browserLang = this.cookieService.get("lang");
        if (this.cookieService.check("lang")) {
            this.language = browserLang == 'en' ? 'english' : 'german';
        }
    }

    handleMeResponse(r: MeResponse) {
        if (!r.consentStatus.consentRequired) {
            this.screen = "content"
            return
        }
        this.screen = r.consentStatus.consentType === "coachee-ai-usage" ? "ai-consent" : "dpa-consent"
    }

    handleAcceptAi() {
        const me = this;
        me.pending = true;
        this._coacheeService.consentToAi({ agreeToAiUsage: true }).then((r) => {
            this.screen = "content"
        })
    }

    handleRejectAi() {
        const me = this;
        me.pending = true;
        this._coacheeService.consentToAi({ agreeToAiUsage: false }).then((r) => {
            this.screen = "content"
        })
    }

    handleLogout() {
        sessionStorage.removeItem('isCoach');
        sessionStorage.removeItem('isCoachee');
        localStorage.removeItem('isCoach');
        localStorage.removeItem('isCoachee');

        sessionStorage.removeItem("storedCoachInfo");
        sessionStorage.removeItem("storedCoacheeUserInfo");

        if (localStorage.getItem("storedCoachInfo")) {
            localStorage.removeItem("storedCoachInfo");
        }

        if (localStorage.getItem("storedCoacheeUserInfo")) {
            localStorage.removeItem("storedCoacheeUserInfo");
        }

        this._coacheeService.coacheeLogout().subscribe(() => window.location.assign('/account/coachee-login'));
    }

    handleRecordConsent() {
        const me = this;
        me.pending = true;
        this._coacheeService.consentToDpa({ agreeToDataProtection: this.dpaChecked }).then((r) => {
            this.screen = r.status === "accepted" ? "content" : "content"
        })
    }

    get submitEnabled(): boolean {
        return !this.pending && this.dpaChecked
    }
}